import { Controller } from "stimulus";
import { Modal } from "bootstrap";

export default class RegistrationFormController extends Controller {
  static targets = ['modal', 'form', 'serverError', 'formError', 'errors'];

  initialize() {
    console.log("Hello, Registration", this.element);

    this.modal = new Modal(this.modalTarget, {
      keyboard: true,
      show: true,
      backdrop: true
    })

    document.addEventListener("registrationModal.show", (event) => {
      this.modal.show();
    }, false);

    const form = this.formTarget;
    form.setAttribute('novalidate', 'novalidate');

    form.addEventListener('submit', (event) => {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    }, false);

    form.addEventListener('ajax:error', (event) => {
      this.showAlert(this.serverErrorTarget);
    });

    document.addEventListener("registration.error", (event) => {
      this.showErrors(event.detail.errors);

      this.showAlert(this.formErrorTarget);
    }, false);

    document.addEventListener("registration.success", (event) => {
      this.modal.hide();
      Turbolinks.visit('/');
    }, false);
  }

  showAlert(element) {
    element.style.display = "block";
    setTimeout(() => {
      element.classList.add('show');
    }, 300);
  }

  hideAlert(event) {
    const element = event.target.parentElement.parentElement;
    element.classList.remove('show');
    setTimeout(() => {
      element.style.display = "none";
    }, 300);
  }

  showErrors(errors) {
    this.errorsTarget.innerText = errors;
  }
}
